import { j as u, c as i } from "./utils-BdNIfrGQ.js";
import { c as l } from "./index-Di82Y7n3.js";
const r = l("", {
  variants: {
    variant: {
      circle: "aspect-square rounded-full h-fit w-full",
      // 1:1
      square: "aspect-square rounded-md h-fit w-full",
      // 1:1
      picture: "aspect-[4/3] h-full w-full object-cover",
      // 4:3
      video: "aspect-video h-full w-full object-cover",
      // 16:9
      auto: "w-auto h-auto",
      fluid: "w-full h-auto",
      full: "w-full h-full"
    }
  },
  defaultVariants: {
    variant: "fluid"
  }
}), f = l("shrink-0", {
  variants: {
    size: {
      xs: "w-[40px]",
      // 4 x 10
      sm: "w-[60px]",
      // 4 x 15
      md: "w-[80px]",
      // 4 x 20
      lg: "w-[96px]",
      // 4 x 25
      xl: "w-[140px]",
      // 4 x 35
      "2xl": "w-[220px]"
      // 4 x 55
    }
  }
}), m = ({
  variant: t,
  spacing: c,
  className: s,
  loading: e = "lazy",
  ...a
}) => (
  // The props object has a mandatory alt prop in it and is spread into the primitive img.
  /* @__PURE__ */ u.jsx(
    "img",
    {
      ...a,
      className: i(r({ variant: t }), s, "object-center max-h-inherit"),
      loading: e,
      alt: a.alt || ""
    }
  )
);
export {
  m as I,
  f as s
};
